var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFylla5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4844,
    height: 58,
    viewBox: "0 0 4844 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.869 3.81655V0.0377871H333.096V0H320.221L356.658 58H369.533L364.559 48.5907H389.431V44.8119H362.351L336.513 3.81655H365.869Z",
    fill: "#F42272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 0L435.832 40.1426L387.572 0H371.771L435.832 50.2312V58H448.356V47.201L439.658 0H423.74Z",
    fill: "#F42272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M494.809 54.2212L458.372 0H445.497L481.934 58H527.583V54.2212H494.809Z",
    fill: "#F42272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546.36 54.2212L509.922 0H497.047L533.485 58H579.133V54.2212H546.36Z",
    fill: "#F42272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M641.218 58H655.264L590.149 0H577.274L585.036 58H599.082L601.081 50.4802H631.972L641.218 58ZM601.081 46.7013L594.124 18.6108L627.407 46.7013H601.081Z",
    fill: "#F42272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M678.867 3.81655V0.0377871H646.094V0H633.219L669.656 58H682.531L677.557 48.5907H702.429V44.8119H675.349L649.511 3.81655H678.867Z",
    fill: "#F42272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M736.738 0L748.83 40.1426L700.571 0H684.769L748.83 50.2312V58H761.354V47.201L752.656 0H736.738Z",
    fill: "#F42272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M807.808 54.2212L771.37 0H758.495L794.932 58H840.581V54.2212H807.808Z",
    fill: "#F42272"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M859.358 54.2212L822.92 0H810.045L846.483 58H892.131V54.2212H859.358Z",
    fill: "#F42272"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M954.216 58H968.262L903.147 0H890.272L898.034 58H912.08L914.079 50.4802H944.97L954.216 58ZM914.079 46.7013L907.122 18.6108L940.405 46.7013H914.079Z",
    fill: "#F42272"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.648 3.81655V0.0377871H12.8751V0H0L36.4371 58H49.3122L44.3387 48.5907H69.2102V44.8119H42.1303L16.2918 3.81655H45.648Z",
    fill: "#F42272"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.519 0L115.611 40.1426L67.3518 0H51.5506L115.611 50.2312V58H128.135V47.201L119.437 0H103.519Z",
    fill: "#F42272"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.589 54.2212L138.151 0H125.276L161.714 58H207.362V54.2212H174.589Z",
    fill: "#F42272"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M226.139 54.2212L189.702 0H176.826L213.264 58H258.912V54.2212H226.139Z",
    fill: "#F42272"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.998 58H335.043L269.928 0H257.053L264.815 58H278.861L280.86 50.4802H311.751L320.998 58ZM280.86 46.7013L273.904 18.6108L307.186 46.7013H280.86Z",
    fill: "#F42272"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.87 3.81655V0.0377871H1302.1V0H1289.22L1325.66 58H1338.53L1333.56 48.5907H1358.43V44.8119H1331.35L1305.51 3.81655H1334.87Z",
    fill: "#F42272"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.74 0L1404.83 40.1426L1356.57 0H1340.77L1404.83 50.2312V58H1417.36V47.201L1408.66 0H1392.74Z",
    fill: "#F42272"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1463.81 54.2212L1427.37 0H1414.5L1450.93 58H1496.58V54.2212H1463.81Z",
    fill: "#F42272"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.36 54.2212L1478.92 0H1466.05L1502.48 58H1548.13V54.2212H1515.36Z",
    fill: "#F42272"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.22 58H1624.26L1559.15 0H1546.27L1554.04 58H1568.08L1570.08 50.4802H1600.97L1610.22 58ZM1570.08 46.7013L1563.12 18.6108L1596.41 46.7013H1570.08Z",
    fill: "#F42272"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.87 3.81655V0.0377871H1615.09V0H1602.22L1638.66 58H1651.53L1646.56 48.5907H1671.43V44.8119H1644.35L1618.51 3.81655H1647.87Z",
    fill: "#F42272"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1705.74 0L1717.83 40.1426L1669.57 0H1653.77L1717.83 50.2312V58H1730.35V47.201L1721.66 0H1705.74Z",
    fill: "#F42272"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.81 54.2212L1740.37 0H1727.49L1763.93 58H1809.58V54.2212H1776.81Z",
    fill: "#F42272"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1828.36 54.2212L1791.92 0H1779.04L1815.48 58H1861.13V54.2212H1828.36Z",
    fill: "#F42272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1923.22 58H1937.26L1872.15 0H1859.27L1867.03 58H1881.08L1883.08 50.4802H1913.97L1923.22 58ZM1883.08 46.7013L1876.12 18.6108L1909.41 46.7013H1883.08Z",
    fill: "#F42272"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.65 3.81655V0.0377871H981.875V0H969L1005.44 58H1018.31L1013.34 48.5907H1038.21V44.8119H1011.13L985.292 3.81655H1014.65Z",
    fill: "#F42272"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.52 0L1084.61 40.1426L1036.35 0H1020.55L1084.61 50.2312V58H1097.14V47.201L1088.44 0H1072.52Z",
    fill: "#F42272"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.59 54.2212L1107.15 0H1094.28L1130.71 58H1176.36V54.2212H1143.59Z",
    fill: "#F42272"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.14 54.2212L1158.7 0H1145.83L1182.26 58H1227.91V54.2212H1195.14Z",
    fill: "#F42272"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1290 58H1304.04L1238.93 0H1226.05L1233.81 58H1247.86L1249.86 50.4802H1280.75L1290 58ZM1249.86 46.7013L1242.9 18.6108L1276.19 46.7013H1249.86Z",
    fill: "#F42272"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2304.87 3.81655V0.0377871H2272.1V0H2259.22L2295.66 58H2308.53L2303.56 48.5907H2328.43V44.8119H2301.35L2275.51 3.81655H2304.87Z",
    fill: "#F42272"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2362.74 0L2374.83 40.1426L2326.57 0H2310.77L2374.83 50.2312V58H2387.36V47.201L2378.66 0H2362.74Z",
    fill: "#F42272"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2433.81 54.2212L2397.37 0H2384.5L2420.93 58H2466.58V54.2212H2433.81Z",
    fill: "#F42272"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2485.36 54.2212L2448.92 0H2436.05L2472.48 58H2518.13V54.2212H2485.36Z",
    fill: "#F42272"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2580.22 58H2594.26L2529.15 0H2516.27L2524.04 58H2538.08L2540.08 50.4802H2570.97L2580.22 58ZM2540.08 46.7013L2533.12 18.6108L2566.41 46.7013H2540.08Z",
    fill: "#F42272"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2617.87 3.81655V0.0377871H2585.09V0H2572.22L2608.66 58H2621.53L2616.56 48.5907H2641.43V44.8119H2614.35L2588.51 3.81655H2617.87Z",
    fill: "#F42272"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2675.74 0L2687.83 40.1426L2639.57 0H2623.77L2687.83 50.2312V58H2700.35V47.201L2691.66 0H2675.74Z",
    fill: "#F42272"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2746.81 54.2212L2710.37 0H2697.5L2733.93 58H2779.58V54.2212H2746.81Z",
    fill: "#F42272"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2798.36 54.2212L2761.92 0H2749.04L2785.48 58H2831.13V54.2212H2798.36Z",
    fill: "#F42272"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2893.22 58H2907.26L2842.15 0H2829.27L2837.03 58H2851.08L2853.08 50.4802H2883.97L2893.22 58ZM2853.08 46.7013L2846.12 18.6108L2879.41 46.7013H2853.08Z",
    fill: "#F42272"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1984.65 3.81655V0.0377871H1951.88V0H1939L1975.44 58H1988.31L1983.34 48.5907H2008.21V44.8119H1981.13L1955.29 3.81655H1984.65Z",
    fill: "#F42272"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2042.52 0L2054.61 40.1426L2006.35 0H1990.55L2054.61 50.2312V58H2067.14V47.201L2058.44 0H2042.52Z",
    fill: "#F42272"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2113.59 54.2212L2077.15 0H2064.28L2100.71 58H2146.36V54.2212H2113.59Z",
    fill: "#F42272"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2165.14 54.2212L2128.7 0H2115.83L2152.26 58H2197.91V54.2212H2165.14Z",
    fill: "#F42272"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2260 58H2274.04L2208.93 0H2196.05L2203.81 58H2217.86L2219.86 50.4802H2250.75L2260 58ZM2219.86 46.7013L2212.9 18.6108L2246.19 46.7013H2219.86Z",
    fill: "#F42272"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3272.87 3.81655V0.0377871H3240.1V0H3227.22L3263.66 58H3276.53L3271.56 48.5907H3296.43V44.8119H3269.35L3243.51 3.81655H3272.87Z",
    fill: "#F42272"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3330.74 0L3342.83 40.1426L3294.57 0H3278.77L3342.83 50.2312V58H3355.36V47.201L3346.66 0H3330.74Z",
    fill: "#F42272"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3401.81 54.2212L3365.37 0H3352.5L3388.93 58H3434.58V54.2212H3401.81Z",
    fill: "#F42272"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3453.36 54.2212L3416.92 0H3404.05L3440.48 58H3486.13V54.2212H3453.36Z",
    fill: "#F42272"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3548.22 58H3562.26L3497.15 0H3484.27L3492.04 58H3506.08L3508.08 50.4802H3538.97L3548.22 58ZM3508.08 46.7013L3501.12 18.6108L3534.41 46.7013H3508.08Z",
    fill: "#F42272"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3585.87 3.81655V0.0377871H3553.09V0H3540.22L3576.66 58H3589.53L3584.56 48.5907H3609.43V44.8119H3582.35L3556.51 3.81655H3585.87Z",
    fill: "#F42272"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M3643.74 0L3655.83 40.1426L3607.57 0H3591.77L3655.83 50.2312V58H3668.35V47.201L3659.66 0H3643.74Z",
    fill: "#F42272"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3714.81 54.2212L3678.37 0H3665.5L3701.93 58H3747.58V54.2212H3714.81Z",
    fill: "#F42272"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M3766.36 54.2212L3729.92 0H3717.04L3753.48 58H3799.13V54.2212H3766.36Z",
    fill: "#F42272"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M3861.22 58H3875.26L3810.15 0H3797.27L3805.03 58H3819.08L3821.08 50.4802H3851.97L3861.22 58ZM3821.08 46.7013L3814.12 18.6108L3847.41 46.7013H3821.08Z",
    fill: "#F42272"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2952.65 3.81655V0.0377871H2919.88V0H2907L2943.44 58H2956.31L2951.34 48.5907H2976.21V44.8119H2949.13L2923.29 3.81655H2952.65Z",
    fill: "#F42272"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3010.52 0L3022.61 40.1426L2974.35 0H2958.55L3022.61 50.2312V58H3035.14V47.201L3026.44 0H3010.52Z",
    fill: "#F42272"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3081.59 54.2212L3045.15 0H3032.28L3068.71 58H3114.36V54.2212H3081.59Z",
    fill: "#F42272"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3133.14 54.2212L3096.7 0H3083.83L3120.26 58H3165.91V54.2212H3133.14Z",
    fill: "#F42272"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3228 58H3242.04L3176.93 0H3164.05L3171.81 58H3185.86L3187.86 50.4802H3218.75L3228 58ZM3187.86 46.7013L3180.9 18.6108L3214.19 46.7013H3187.86Z",
    fill: "#F42272"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4240.87 3.81655V0.0377871H4208.1V0H4195.22L4231.66 58H4244.53L4239.56 48.5907H4264.43V44.8119H4237.35L4211.51 3.81655H4240.87Z",
    fill: "#F42272"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4298.74 0L4310.83 40.1426L4262.57 0H4246.77L4310.83 50.2312V58H4323.36V47.201L4314.66 0H4298.74Z",
    fill: "#F42272"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4369.81 54.2212L4333.37 0H4320.5L4356.93 58H4402.58V54.2212H4369.81Z",
    fill: "#F42272"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4421.36 54.2212L4384.92 0H4372.05L4408.48 58H4454.13V54.2212H4421.36Z",
    fill: "#F42272"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4516.22 58H4530.26L4465.15 0H4452.27L4460.04 58H4474.08L4476.08 50.4802H4506.97L4516.22 58ZM4476.08 46.7013L4469.12 18.6108L4502.41 46.7013H4476.08Z",
    fill: "#F42272"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M4553.87 3.81655V0.0377871H4521.09V0H4508.22L4544.66 58H4557.53L4552.56 48.5907H4577.43V44.8119H4550.35L4524.51 3.81655H4553.87Z",
    fill: "#F42272"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4611.74 0L4623.83 40.1426L4575.57 0H4559.77L4623.83 50.2312V58H4636.35V47.201L4627.66 0H4611.74Z",
    fill: "#F42272"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M4682.81 54.2212L4646.37 0H4633.5L4669.93 58H4715.58V54.2212H4682.81Z",
    fill: "#F42272"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M4734.36 54.2212L4697.92 0H4685.04L4721.48 58H4767.13V54.2212H4734.36Z",
    fill: "#F42272"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4829.22 58H4843.26L4778.15 0H4765.27L4773.03 58H4787.08L4789.08 50.4802H4819.97L4829.22 58ZM4789.08 46.7013L4782.12 18.6108L4815.41 46.7013H4789.08Z",
    fill: "#F42272"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M3920.65 3.81655V0.0377871H3887.88V0H3875L3911.44 58H3924.31L3919.34 48.5907H3944.21V44.8119H3917.13L3891.29 3.81655H3920.65Z",
    fill: "#F42272"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M3978.52 0L3990.61 40.1426L3942.35 0H3926.55L3990.61 50.2312V58H4003.14V47.201L3994.44 0H3978.52Z",
    fill: "#F42272"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M4049.59 54.2212L4013.15 0H4000.28L4036.71 58H4082.36V54.2212H4049.59Z",
    fill: "#F42272"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4101.14 54.2212L4064.7 0H4051.83L4088.26 58H4133.91V54.2212H4101.14Z",
    fill: "#F42272"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M4196 58H4210.04L4144.93 0H4132.05L4139.81 58H4153.86L4155.86 50.4802H4186.75L4196 58ZM4155.86 46.7013L4148.9 18.6108L4182.19 46.7013H4155.86Z",
    fill: "#F42272"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFylla5);
export default __webpack_public_path__ + "static/media/fylla5.8982dd5404e29202faea83264203fd26.svg";
export { ForwardRef as ReactComponent };